import {computed, inject, Injectable, signal} from '@angular/core';
import {AuthStore} from '@auth/data-access';
import {DeviceService} from '@shared/device';
import {Router, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class SidenavService {
	private readonly authStore = inject(AuthStore);
	private readonly deviceService = inject(DeviceService);
	private readonly router = inject(Router);
	
	public readonly isSidenavAvailable = computed(() => this.authStore.isAuthenticated() && this.authStore.isPermanent());

	private _collapsed = signal<boolean>(true);
	public collapsed = this._collapsed.asReadonly();

	constructor() {
		// האזנה לאירועי ניווט כדי לסגור את הסיידנב במובייל אחרי ניווט
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(() => {
			if (this.deviceService.isMobile()) {
				this.setCollapsed(true);
			}
		});
	}

	toggleCollapsed(): void {
		this._collapsed.update(state => !state);
		this.saveToLocalStorage();
	}

	setCollapsed(value: boolean): void {
		this._collapsed.set(value);
		this.saveToLocalStorage();
	}

	initFromLocalStorage(): void {
		// במובייל - תמיד להתחיל בסגור
		if (this.deviceService.isMobile()) {
			this._collapsed.set(true);
			return;
		}
		
		const savedState = localStorage.getItem('sidenav_collapsed');
		if (savedState) {
			this._collapsed.set(savedState === 'true');
		}
	}

	public saveToLocalStorage(): void {
		// לא לשמור מצב במובייל - תמיד סגור
		if (this.deviceService.isMobile()) {
			return;
		}
		localStorage.setItem('sidenav_collapsed', this._collapsed().toString());
	}

	public readonly ActiveGroup = {
		activeGroupId: signal<string | undefined>(undefined),
		onGroupClick: (groupId: string): void => {
			const currentActiveGroupId = this.ActiveGroup.activeGroupId();
			if (currentActiveGroupId === groupId) {
				this.ActiveGroup.activeGroupId.set(undefined);
			} else {
				this.ActiveGroup.activeGroupId.set(groupId);
			}
		},
	};
}
